type ModalHeroBlockProps = {
  url: string
}

/**
 * Artwork painted edge to edge across the dialog.
 *
 * Cropped to a band rather than shown at its own height: a hero is a header,
 * and one uploaded at a tall shape would otherwise push the copy off the first
 * screen. Mobile gets a shorter band because the dialog is narrower there and
 * the same ratio would leave a sliver. The bleed past the dialog's padding is
 * the card's job — see `blockFrameClass` in `modal-card.tsx`.
 */
export const ModalHeroBlock = ({ url }: ModalHeroBlockProps) => (
  <img
    alt=""
    className="block aspect-[16/5] w-full object-cover sm:aspect-[7/3]"
    data-tst="announcement-modal-hero"
    src={url}
  />
)
